import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { k as getTheme } from './utils2.js';

const mapyReviewButtonCss = ":host{display:inline-flex;border-radius:4px}a,button{width:100%;height:100%;display:flex;justify-content:center;align-items:center;font-family:Arial, Helvetica, sans-serif;font-size:14px;font-weight:700;line-height:20px;letter-spacing:0px;text-align:center;text-decoration:none;padding:8px;border:0;border-radius:4px;background:#e7eee6;color:#1eae00;user-select:none;cursor:pointer}a[disabled],button[disabled]{background:#ccc;color:#fff}a:hover:not([disabled]),a:focus:not([disabled]),button:hover:not([disabled]),button:focus:not([disabled]){background:#c4e4bd;color:#187f00}:host([primary]) a,:host([primary]) button{background:#1eae00;color:#ffffff}:host([primary]) a:hover:not([disabled]),:host([primary]) a:focus:not([disabled]),:host([primary]) button:hover:not([disabled]),:host([primary]) button:focus:not([disabled]){background:#187f00}:host([primary]) a[disabled],:host([primary]) button[disabled]{background:#ccc;color:#fff;cursor:default}:host([data-theme=\"firmy\"]) a,:host([data-theme=\"firmy\"]) button{color:#fff;background:#c00}:host([data-theme=\"firmy\"]) a[disabled],:host([data-theme=\"firmy\"]) button[disabled]{color:#fff;background:#ed8383}:host([data-theme=\"firmy\"]) a:hover:not([disabled]),:host([data-theme=\"firmy\"]) a:focus:not([disabled]),:host([data-theme=\"firmy\"]) button:hover:not([disabled]),:host([data-theme=\"firmy\"]) button:focus:not([disabled]){background:#a00000;color:#fff}";
const MapyReviewButtonStyle0 = mapyReviewButtonCss;

const MapyReviewButton = /*@__PURE__*/ proxyCustomElement(class MapyReviewButton extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.primary = false;
        this.disabled = false;
        this.download = undefined;
        this.href = undefined;
        this.rel = undefined;
        this.target = undefined;
        this.type = "button";
        this.service = "mapy";
    }
    render() {
        const { type, disabled, rel, target, href, } = this;
        const TagType = href === undefined ? "button" : "a";
        const attrs = TagType === "button"
            ? { type }
            : {
                download: this.download,
                href: disabled ? undefined : href,
                rel,
                target,
            };
        return (h(Host, { key: '30b4e7063b9860747f4d69b1c00224d8b49db3ac', "aria-disabled": disabled ? "true" : null, "data-theme": getTheme(this.service) }, h(TagType, Object.assign({ key: 'fbf441b226f937de1100b9dd87ff595f3c9f98d3' }, attrs, { disabled: disabled }), h("slot", { key: '2d0f49c6ef5cd12ff1eaf72c292aa544c391c035' }))));
    }
    static get style() { return MapyReviewButtonStyle0; }
}, [1, "mapy-review-button", {
        "primary": [516],
        "disabled": [516],
        "download": [513],
        "href": [513],
        "rel": [513],
        "target": [513],
        "type": [513],
        "service": [513]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-button"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-button":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewButton);
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewButton as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-button2.js.map